"use client";

import { useTina } from "@/lib/utils";
import { createContext, useContext } from "react";

const TinaGlobalContext = createContext({});

export function TinaGlobalProvider({ globalData, children }) {
  const { data } = useTina({
    query: globalData.query,
    variables: globalData.variables,
    data: globalData.data,
  });

  return <TinaGlobalContext.Provider value={data.globalUi}>{children}</TinaGlobalContext.Provider>;
}

export function useGlobalData() {
  return useContext(TinaGlobalContext);
}
